/** SalesWorkx brand tokens — EstateFlow-inspired chrome, SalesWorkx palette */
export const BRAND_NAVY = '#042663'
export const BRAND_NAVY_HOVER = '#031a4d'
export const BRAND_NAVY_LIGHT = '#0d3b8d'
export const BRAND_NAVY_ACTIVE = 'rgba(255,255,255,0.14)'
export const BRAND_GREEN = '#7ED321'
export const BRAND_GREEN_HOVER = '#6bc41a'
export const BRAND_ORANGE = '#FF6B00'
export const PAGE_BG = '#F3F4F6'
export const SURFACE_WHITE = '#FFFFFF'
export const BORDER_LIGHT = '#E5E7EB'

/** Primary CTA — navy solid buttons */
export const btnPrimaryStyle = {
  backgroundColor: BRAND_NAVY,
  borderColor: BRAND_NAVY,
}

/** Success / Activate actions only */
export const btnSuccessStyle = {
  backgroundColor: BRAND_GREEN,
  borderColor: BRAND_GREEN,
}

/** Outline secondary action */
export const btnOutlineStyle = {
  backgroundColor: SURFACE_WHITE,
  borderColor: BORDER_LIGHT,
  color: '#374151',
}
